import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paymentfailure',
  templateUrl: './paymentfailure.component.html',
  styleUrls: ['./paymentfailure.component.css']
})
export class PaymentfailureComponent implements OnInit {

  public data;
  constructor() { }

  ngOnInit() {
  }

}
